import { NgModule } from '@angular/core';

import { provideFormlyConfig } from '@ngx-formly/core';

import { OtpFormFieldUiComponent } from './otp-form-field-ui/otp-form-field-ui.component';

@NgModule({
  imports: [OtpFormFieldUiComponent],
  declarations: [],
  exports: [],
  providers: [
    provideFormlyConfig({
      types: [
        {
          name: 'otp',
          component: OtpFormFieldUiComponent,
          wrappers: ['form-field-labeled'],
        },
      ],
    }),
  ],
})
export class OtpSharedFormUiFieldModule {}
